import React from 'react'
import './css/HomeTestimonials.css'
import TestimonialCard from './TestimonialCard'
import User from './../assets/images/User.jpg'

function HomeTestimonials() {
  return (
    <div className='HomeTestimonials'>
        <h1>What our clients say</h1>
        <div className='cards'>
            <TestimonialCard icon={User} content={"“The food served was yummy and the staff were very active to ensure a pleasant buffet experience. They ensure that everyone is attended and served food with love.”"} name={"Kiran Chand CS"}/>
            <TestimonialCard icon={User} content={"“As promised, food was so delicious and their service was excellent. Everything was setup so nicely and they managed so well. They have an organised team to make the event a great success.”"} name={"Ajish Kumar"}/>
            <TestimonialCard icon={User} content={"“We were so pleased with the presentation of the meal and the exemplary service of all your staff. Everyone commented on how delicious and sophisticated the items were.”"} name={"Sneha Anna"}/>
        </div>
    </div>
  )
}

export default HomeTestimonials